/* DSL Geo currency — pin display-currency op basis van Cloudflare CDN-Country (in cookie of header) of Shopify shop.country fallback */
(function(){
  var KEY = "dsl_currency_geo";
  var seen = (function(){ try { return localStorage.getItem(KEY); } catch(e){ return null; } })();
  if (seen) return; // user already chose
  // Try Cloudflare CF-IPCountry meta or fallback to navigator.language
  var country = (document.cookie.match(/__cf_country=([A-Z]{2})/) || [])[1] || (navigator.language || "").split("-")[1];
  if (!country) return;
  var MAP = {NL: "EUR", BE: "EUR", DE: "EUR", FR: "EUR", AT: "EUR", IT: "EUR", ES: "EUR", IE: "EUR", PT: "EUR", FI: "EUR", LU: "EUR", GB: "GBP", US: "USD", CA: "CAD", AU: "AUD"};
  var cur = MAP[country.toUpperCase()];
  if (cur && window.DSL_CURRENCY && window.DSL_CURRENCY.get() !== cur) {
    window.DSL_CURRENCY.set(cur);
    if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Prijzen worden getoond in " + cur + ". <a href=\"#\" data-cur-revert>EUR</a>", variant: "info", duration: 8000});
  }
  document.addEventListener("click", function(e){
    if (e.target.matches("[data-cur-revert]")) { e.preventDefault(); window.DSL_CURRENCY && window.DSL_CURRENCY.set("EUR"); }
  });
})();